(function () {
  if (window.__fh2Geladen) return;
  window.__fh2Geladen = true;

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (z) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[z];
    });
  }

  var _decEl = document.createElement('textarea');
  function _dec(t) {
    if (t == null || t === '') return '';
    _decEl.innerHTML = String(t);
    return _decEl.value;
  }

  var T = null;
  function t(k, platz) {
    if (!T) {
      T = {};
      try {
        var el = document.querySelector('script[data-fh2-texte]');
        if (el) T = JSON.parse(el.textContent) || {};
      } catch (e) { T = {}; }
    }
    var s = T[k] || '';
    if (s && platz) s = s.replace(/\{(\w+)\}/g, function (m, n) { return platz[n] != null ? platz[n] : m; });
    return s;
  }

  function proxy() {
    return (window.FinderClean && window.FinderClean.proxy) || '/apps/monitor-db';
  }

  function finderFeld() { return document.querySelector('.fn-slot-inp'); }

  function finderZiel() {
    return document.querySelector('.fn-section') || document.getElementById('fn-result');
  }

  function finderDa() { return !!(finderZiel() || finderFeld()); }

  function rollen() {
    var ziel = finderZiel() || finderFeld();
    if (ziel && ziel.scrollIntoView) ziel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function aufdecken() { document.dispatchEvent(new CustomEvent('finder:einstieg')); }

  function mitFinder(fn) {
    if (window.FinderClean && window.FinderClean.waehleMonitor) { fn(); return; }
    document.addEventListener('finder:bereit', fn, { once: true });
  }

  function monitorSetzen(ref) {
    aufdecken();
    mitFinder(function () {
      if (!(window.FinderClean && window.FinderClean.waehleMonitor)) { rollen(); return; }
      Promise.resolve(window.FinderClean.waehleMonitor(ref)).then(rollen).catch(rollen);
    });
  }

  function adresseMit(basis, schluessel, wert) {
    return basis + (basis.indexOf('?') > -1 ? '&' : '?') + schluessel + '=' + encodeURIComponent(wert);
  }

  var WAHL_KEY = '3idee_auswahl';

  function gewaehlt() {
    try {
      var roh = localStorage.getItem(WAHL_KEY);
      if (!roh) return null;
      var a = JSON.parse(roh);
      return (a && a.name) ? a : null;
    } catch (e) { return null; }
  }

  function wahlZeichnen() {
    var a = gewaehlt();
    var imFinder = finderDa();
    document.querySelectorAll('[data-fh2-form]').forEach(function (f) { f.hidden = !!a && !f.querySelector('[data-fn-ladeaus]'); });
    document.querySelectorAll('[data-fh2-wahl]').forEach(function (w) {
      w.hidden = !a || imFinder;
      if (!a) return;
      var name = w.querySelector('[data-fh2-wahl-name]');
      var mehr = w.querySelector('[data-fh2-wahl-mehr]');
      if (name) name.textContent = a.name;
      if (mehr) {
        var weitere = (a.anzahl || 1) - 1;
        mehr.hidden = weitere < 1;
        mehr.textContent = weitere > 0 ? (t('weitere', { anzahl: weitere }) || '+' + weitere + ' weitere') : '';
      }
    });
  }


  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var ansehen = e.target.closest('[data-fh2-wahl-ansehen]');
    if (ansehen) {
      e.preventDefault();
      if (finderDa()) { aufdecken(); rollen(); }
      else {
        var w = ansehen.closest('[data-fh2-wahl]');
        var ziel = (w && w.getAttribute('data-fh2-ziel')) || '/';
        window.location.href = adresseMit(ziel, 'setup', '1');
      }
      return;
    }

  }, true);

  document.querySelectorAll('[data-fh2-form]').forEach(function (form) {
    if (form.__fh2) return;
    form.__fh2 = true;

    var eingabe = form.querySelector('[data-fh2-input]');
    var liste = form.querySelector('[data-fh2-dd]');
    var wurzel = form.closest('.finder-hero') || form.parentNode || form;
    var zielSeite = form.getAttribute('data-fh2-ziel') || '';
    var uhr = null, letzte = '';

    function listeZu() {
      if (!liste) return;
      liste.innerHTML = '';
      liste.hidden = true;
      wurzel.classList.remove('finder-hero--liste-offen');
    }

    function listeMessen() {
      if (window.Suchebene) window.Suchebene.messen();
    }
    function listeMessenAn() {}

    function listeAuf(html) {
      if (!liste) return;
      liste.innerHTML = html;
      liste.hidden = false;
      wurzel.classList.add('finder-hero--liste-offen');
      listeMessenAn();
      listeMessen();
    }

    function suchen(q) {
      var url = proxy() + '/monitors/search?q=' + encodeURIComponent(q);
      (window.EngineStatus ? window.EngineStatus.hol(url) : fetch(url).then(function (r) { return r.json(); }))
        .then(function (json) {
          if (q !== letzte) return;
          var data = (json && json.data) || {};
          var treffer = (data.found && data.results && data.results.length)
            ? data.results
            : (data.similar || []);
          if (!json || !json.ok || !treffer.length) {
            listeAuf('<p class="fh2__dd-leer">' + esc(form.getAttribute('data-t-leer') || t('leer') || 'Kein Modell gefunden') + '</p>');
            return;
          }
          listeAuf(treffer.map(function (m) {
            var teile = [];
            if (m.series) teile.push(m.series);
            if (m.size_inch) teile.push(parseFloat(m.size_inch) + '"');
            if (m.year) teile.push(m.year);
            return '<button type="button" class="fh2__ddi" data-ref="' + esc(m.ref) + '">'
              + '<span class="fh2__ddi-n">' + esc(m.name) + '</span>'
              + (teile.length ? '<span class="fh2__ddi-s">' + esc(teile.join(' · ')) + '</span>' : '')
              + '</button>';
          }).join(''));
        })
        .catch(function (e) {
          if (q !== letzte) return;
          if (e && e.engineAus && window.EngineStatus) {
            listeAuf(window.EngineStatus.hinweisHtml(t('suche_aus') || 'Die Modellsuche ist gerade nicht erreichbar.', t('wa_text')));
            return;
          }
          listeZu();
        });
    }

    if (eingabe) {
      var phLang = _dec(eingabe.getAttribute('placeholder') || '');
      var phKurz = _dec(form.getAttribute('data-ph-mobil') || '');
      if (phKurz && phKurz !== phLang && window.matchMedia) {
        var schmal = window.matchMedia('(max-width: 1023px)');
        var phSetzen = function () {
          eingabe.setAttribute('placeholder', schmal.matches ? phKurz : phLang);
        };
        phSetzen();
        if (schmal.addEventListener) schmal.addEventListener('change', phSetzen);
        else if (schmal.addListener) schmal.addListener(phSetzen);
      }
    }

    if (window.Suchebene && eingabe && liste) {
      window.Suchebene.binden({
        leiste: form,
        eingabe: eingabe,
        liste: liste,
        zu: listeZu,
        schliessText: form.getAttribute('data-t-schliessen') || t('schliessen') || 'Suche schließen',
        titel: form.getAttribute('data-t-ebene') || t('ebene') || 'Monitor suchen'
      });
    }

    if (eingabe && liste) {
      eingabe.addEventListener('input', function () {
        var q = eingabe.value.trim();
        letzte = q;
        clearTimeout(uhr);
        if (q.length < 2) { listeZu(); return; }
        uhr = setTimeout(function () { suchen(q); }, 180);
      });

      liste.addEventListener('click', function (e) {
        var treffer = e.target.closest('[data-ref]');
        if (!treffer) return;
        var ref = treffer.getAttribute('data-ref');
        eingabe.value = treffer.querySelector('.fh2__ddi-n').textContent;
        listeZu();

        if (finderDa()) monitorSetzen(ref);
        else if (zielSeite) window.location.href = adresseMit(zielSeite, 'monitor', ref);
      });

      form.addEventListener('mousedown', function (e) {
        if (e.target.closest('button, a, input, [data-fh2-dd]')) return;
        e.preventDefault();
        eingabe.focus();
      });

      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-fh2-form]')) listeZu();
      });
      eingabe.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (ebeneAn) ebeneZu(); else listeZu();
      });
    }

    form.addEventListener('submit', function (e) {
      var text = eingabe ? eingabe.value.trim() : '';

      if (!finderDa()) {
        if (!zielSeite) return;
        e.preventDefault();
        window.location.href = text ? adresseMit(zielSeite, 'q', text) : zielSeite;
        return;
      }

      e.preventDefault();
      aufdecken();

      var feld = finderFeld();
      if (feld && text) {
        feld.value = text;
        feld.dispatchEvent(new Event('input', { bubbles: true }));
      }
      rollen();
      if (feld) setTimeout(function () { feld.focus({ preventScroll: true }); }, 420);
    });
  });

  document.querySelectorAll('[data-fh2]').forEach(function (hero) {
    if (!hero.querySelector('.fh2__spot')) return;
    var sanft = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (sanft || !('IntersectionObserver' in window)) return;

    hero.setAttribute('data-fh2-anim', 'bereit');
    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        hero.setAttribute('data-fh2-anim', 'laeuft');
        beobachter.disconnect();
      });
    }, { threshold: 0.35 });
    beobachter.observe(hero);
  });

  wahlZeichnen();
  document.addEventListener('finder:auswahl', wahlZeichnen);
  window.addEventListener('storage', function (e) { if (e.key === WAHL_KEY) wahlZeichnen(); });
  document.addEventListener('finder:auswahl', wahlZeichnen);
  window.addEventListener('pageshow', wahlZeichnen);

  if (window.URLSearchParams) {
    var p = new URLSearchParams(window.location.search);

    if (p.get('setup')) {
      aufdecken();
      rollen();
      mitFinder(function () { setTimeout(rollen, 400); });
    }

    var ref = p.get('monitor');
    var q = p.get('q');
    if (ref) {
      monitorSetzen(ref);
    } else if (q) {
      aufdecken();
      var heroFeld = document.querySelector('[data-fh2-input]');
      if (heroFeld) heroFeld.value = q;
      mitFinder(function () {
        var feld = finderFeld();
        if (feld) {
          feld.value = q;
          feld.dispatchEvent(new Event('input', { bubbles: true }));
        }
        rollen();
      });
    }
  }
})();
